<div class="table-loader">
  <layout-skeleton [skeleton]="skeleton"></layout-skeleton>
</div>
